import React from "react";
import { useNavigate } from "react-router-dom";
import { primaryButtonCls } from "../../../components/ui-components/buttonStyles.js";
import { DIFFERS_OPTIONS } from "./constants";
import { WizardCard } from "./WizardUI";

// Step 2 (spec §3.2): "What needs to differ?" drives which later steps
// matter. The last option — "Nothing, just scope" — is a deliberate dead
// end: creating a new role to change only WHERE it applies duplicates a
// role for no reason when B's data-scope grants already solve that. It's
// only offered once a template is selected (there's no "existing role" to
// go assign otherwise).
export default function StepWhatDiffers({ whatDiffers, setWhatDiffers, cloneCode, cloneSourceRoleName }) {
  const navigate = useNavigate();

  return (
    <WizardCard title="What needs to differ?" subtitle="Your choice determines which of the following steps apply.">
      <div className="space-y-2">
        {DIFFERS_OPTIONS.map((opt) => {
          const disabled = opt.value === "scope_only" && !cloneCode;
          return (
            <label
              key={opt.value}
              className={`flex items-start gap-3 rounded-lg border border-border bg-surface-2/50 p-3 ${
                disabled ? "opacity-50" : "cursor-pointer"
              }`}
            >
              <input
                type="radio"
                name="what-differs"
                value={opt.value}
                checked={whatDiffers === opt.value}
                onChange={() => setWhatDiffers(opt.value)}
                disabled={disabled}
                className="mt-0.5 accent-primary shrink-0"
              />
              <span className="min-w-0">
                <span className="block text-sm text-text">{opt.label}</span>
                <span className="block text-xs text-text-2 mt-0.5">
                  {disabled ? "Only available when starting from a template." : opt.helper}
                </span>
              </span>
            </label>
          );
        })}
      </div>

      {whatDiffers === "scope_only" && cloneCode && (
        <div className="mt-4 rounded-lg border border-primary/30 bg-primary-soft p-4">
          <p className="text-sm text-text">
            You don't need a new role for this. Assign{" "}
            <span className="font-semibold">{cloneSourceRoleName || "the existing template"}</span> to the user with a
            different data scope instead — no new role is created.
          </p>
          <button
            type="button"
            className={`${primaryButtonCls} mt-3`}
            onClick={() => navigate(`/settings/users?role=${cloneCode}`)}
          >
            Go assign the existing role with a scope
          </button>
        </div>
      )}
    </WizardCard>
  );
}
